import React from 'react';
import "./GuaranteedInvestment.css";
import mainImg from "../Investment/Images/guaranteed-plans.png";
import pnbImg from "../Investment/Images/pnbmetlife-logo.png";
import hdfcImg from "../Investment/Images/HDFC_Life_Logo.png";
import aegonImg from "../Investment/Images/Aegon-Life-Logo.png";
import GoogleRating from './UtilityComponents/GoogleRating';

const GuaranteedInvestment = () => {
    return (
        <>
            <div className="containerGuarantee">
                <h4>Guaranteed Investment Plans: <span>Secure Your Financial Future</span> </h4>
                <small className="GITxt">Explore a diverse range of insurance-backed investment options</small>

                <div id="imgContainer" className="hideImgINMob">
                    <img src={mainImg} alt="Guaranteed Plans" id='mainImg' />
                    {/*<div className="bgDiv" id='pnbDiv' ><img src={pnbImg} alt="PNB medlife" id='pnbImg' /></div>
                    <div className="bgDiv" id='hdfcDiv' ><img src={hdfcImg} alt="hdfc" id='hdfcImg' /></div>
                    <div className="bgDiv" id='txtDiv' ><p id='imgTxt'>+ many more</p></div>
                    <div className="bgDiv" id='aegonDiv' ><img src={aegonImg} alt="aegon" id='aegonImg' /></div>*/}

                    <div className="bgDiv" id='pnbDiv' ><div className="partner_logo pnbMet_ins"></div></div>
                    <div className="bgDiv" id='hdfcDiv' ><div className="partner_logo hdfcLife_ins"></div></div>
                    <div className="bgDiv" id='txtDiv' ><p id='imgTxt'>+ many more</p></div>
                    <div className="bgDiv" id='aegonDiv' ><div className="partner_logo bandhan_ins"></div></div>

                    <div id="googleRating">
                        <GoogleRating className="googleRating" />
                    </div>
                </div>

        
            </div>
        </>
    )
}

export default GuaranteedInvestment;
